<template>
  <div class="personal-consult-detail">
    <layoutContainer>
      <!-- 主要内容区域 -->
      <div class="main-content">
        <!-- 左侧信息区域 -->
        <div class="left-section">
          <!-- 基本信息部分 -->
          <div class="basic-info">
            <div class="top-info">
              <div class="user-avatar-section">
                <div class="avatar-content">
                  <img
                    class="user-avatar"
                    :src="consultantInfo.headPicUrl || ''"
                    :alt="`${consultantInfo.nickName || '顾问'}的头像`"
                  />
                  <div class="follow">
                    <el-button
                      class="follow-btn"
                      v-if="!isSelf && consultantInfo.status !== 'offline'"
                      :plain="!hasFollowed"
                      @click="toggleFollow"
                      :loading="followLoading"
                    >
                      <i class="el-icon-star-on" v-if="hasFollowed"></i>
                      <i class="el-icon-star-off" v-else></i>
                      {{ hasFollowed ? '取消关注' : '关注' }}
                    </el-button>
                  </div>

                  <img v-if="consultantInfo.gender === 1" class="gender-icon male" src="/img/man.png" alt="男性" />
                  <img v-else class="gender-icon female" src="/img/hed.png" alt="女性" />
                </div>
                <div class="user-name-section">
                  <div class="user-name" v-if="consultantInfo.nickName">
                    {{ consultantInfo.nickName }}
                    <span
                      v-if="getStatusText(consultantInfo.status) && consultantInfo.status !== 1"
                      class="status-badge"
                      :class="getStatusClass(consultantInfo.status)"
                    >
                      （{{ getStatusText(consultantInfo.status) || '-' }}）
                    </span>
                  </div>
                  <div class="city-info" v-if="areaName">
                    <!-- <i class="el-icon-location"></i> -->
                    <img src="/img/loc-detail.png" alt="" class="loc-img" />
                    {{ areaName }}
                  </div>
                </div>
              </div>
              <div class="action-buttons">
                <el-button class="action-btn" @click="goToPersonalPage">
                  个人主页
                </el-button>
                <el-button class="action-btn default" @click="goToBargainPage">
                  砍价
                </el-button>
              </div>
              <div v-if="canShowAppointmentButton" class="appointment-section">
                <el-button type="primary" size="large" @click="openAppointmentDialog" class="appointment-btn">
                  预约
                </el-button>
              </div>
            </div>
            <!-- 数据展示区 -->
            <div class="data-display">
              <div class="data-item">
                <div class="label">职业</div>
                <div class="value">{{ consultantInfo.occupationName || '？' }}</div>
              </div>
              <div class="data-item">
                <div class="label">工作年限</div>
                <div class="value">{{ consultantInfo.workYears ? `${consultantInfo.workYears}年` : '？' }}</div>
              </div>
              <div class="data-item">
                <div class="label">预约价格</div>
                <div class="value price-value">
                  <span v-if="consultantInfo.discountPrice" class="current-price"
                    >¥{{ consultantInfo.discountPrice || consultantInfo.originalPrice }}/小时</span
                  >
                  <span v-if="consultantInfo.hasDiscount && consultantInfo.originalPrice" class="original-price">
                    ¥{{ consultantInfo.originalPrice }}
                  </span>
                  <span v-else>?</span>
                  <el-tooltip
                    v-if="(isSelf || isOperator) && consultantInfo.originalPrice"
                    effect="dark"
                    placement="top"
                  >
                    <div slot="content">
                      到手金额为预约价格的80%，可在预约订单超过7天可退款期限后，到个人中心的钱包处自行提现
                    </div>
                    <!-- <i class="el-icon-question price-tip-icon"></i> -->
                    <img src="/img/qa.png" alt="" class="question-icon" />
                  </el-tooltip>
                </div>
              </div>
              <div class="data-item">
                <div class="label">被预约量</div>
                <div class="value">
                  <span v-if="consultantInfo.saleNum">{{ consultantInfo.saleNum }}单</span>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="data-item">
                <div class="label">评价</div>
                <div class="value">
                  <span v-if="consultantInfo.evaluationScore" class="rating-display">
                    {{ consultantInfo.evaluationScore }}分
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>

            <!-- 详细信息区域 -->
            <div class="detail-info">
              <div v-if="hasFamousCompanies" class="info-section">
                <p class="section-title">名企经历</p>
                <div class="company-list">
                  <span
                    v-for="company in consultantInfo.workedFamousCompanyList"
                    :key="company.id"
                    class="company-item"
                  >
                    {{ company }}
                  </span>
                </div>
              </div>

              <div class="info-section">
                <p class="section-title">擅长知识</p>
                <div class="knowledge-list">
                  <span
                    v-for="knowledge in consultantInfo.knowledgeList"
                    :key="knowledge.id || knowledge"
                    class="knowledge-item"
                  >
                    {{ knowledge.title || knowledge }}
                  </span>
                </div>
              </div>

              <div class="info-section">
                <p class="section-title">个人简介</p>
                <div class="introduction-wrapper">
                  <p class="introduction">
                    {{ consultantInfo.introduction || '暂无简介' }}
                  </p>
                  <div class="introduction-actions">
                    <!-- <el-dropdown v-if="isSelf" trigger="click">
                      <i class="el-icon-more"></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click="editIntroduction">编辑简介</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown> -->
                  </div>
                </div>
              </div>

              <!-- <div class="info-section">
                <p class="section-title">社保样例视频</p>
                <div class="example-video-wrapper">
                  <a href="#" @click.prevent="goToExampleVideo" class="example-video-link">
                    <i class="el-icon-video-camera"></i>
                    <span>查看社保记录示例视频</span>
                  </a>
                </div>
              </div> -->
            </div>
          </div>
          <!-- todo -->

          <div class="bottom-btn">
            <!-- 收藏 -->
            <div class="collect-btn" :class="hasCollected ? 'active' : ''" @click="toggleCollection">
              <img class="collect-icon" v-if="hasCollected" src="/img/start-icon-active.png" alt="收藏" />
              <img class="collect-icon" v-else src="/img/star-icon.png" alt="收藏" />
              <span v-if="!consultantInfo.collectionNum">收藏</span>
              <span class="collection-num" v-if="consultantInfo.collectionNum">{{ consultantInfo.collectionNum }}</span>
            </div>
            <!-- 分享 -->
            <img class="share-btn" src="/img/share.png" alt="分享" @click="openShareDialog" />
            <!-- 更多 -->
            <el-popover placement="top" width="160" v-model="reportVisible" popper-class="report-popover">
              <div class="report" @click="openReportDialog">
                <img class="report-icon" src="/img/report.png" alt="举报" />
                举报
              </div>
              <img slot="reference" class="more-icon" src="/img/more.png" />
              <!-- <div class="more-btn">
                <img class="more-icon" src="/img/more.png" alt="更多" />
                更多
              </div> -->
            </el-popover>
          </div>

          <!-- 评价区域 -->
          <!-- <div class="evaluation-section">
            <div class="section-header">
              <p class="section-title">
                评价 ({{ consultantInfo.evaluationScore ? consultantInfo.evaluationScore + '分' : '' }} /
                {{ evaluationList.length }}条)
              </p>
              <el-button v-if="canEvaluate" type="primary" size="small" @click="showCommentDialog">
                写评价
              </el-button>
            </div>
            <div class="evaluation-list" v-if="evaluationList.length > 0">
              <div v-for="item in evaluationList" :key="item.id" class="evaluation-item">
                <div class="evaluation-header">
                  <span class="evaluator-name">{{ maskUserName(item.userName) }}</span>
                  <div class="rating-stars">
                    <i v-for="i in 5" :key="i" class="el-icon-star" :class="{active: i <= item.score}" />
                  </div>
                  <span class="evaluation-time">{{ formatTime(item.createTime) }}</span>
                </div>
                <div class="evaluation-content">{{ item.content }}</div>
              </div>
            </div>
            <div v-else class="empty-tip">暂无评价</div>
          </div> -->
        </div>

        <!-- 右侧操作区域 -->
        <!-- <div class="right-section">
          <div class="user-actions">
            <div class="other-actions">
              <div class="action-item" @click="toggleCollection">
                <i :class="hasCollected ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                <span>{{ collectionCount }}</span>
              </div>
              <div class="action-item" @click="showShareDialog">
                <i class="el-icon-share"></i>
                <span>分享</span>
              </div>
              <div class="action-item" @click="toggleMoreActions">
                <i class="el-icon-more"></i>
                <span>更多</span>
              </div>
            </div>
            <transition name="fade">
              <div v-if="showMoreActions" class="more-actions-dropdown" @click.stop>
                <el-button type="text" class="report-btn" @click="openReportDialog">
                  举报
                </el-button>
              </div>
            </transition>
          </div>
        </div> -->
      </div>

      <!-- 操作区组件 -->
      <operation-area
        v-if="isCurrentConsultantUser || isAgentSaler"
        :consultant-info="consultantInfo"
        :consultant-id="consultantId"
        @status-changed="initData"
        :user-status="getStatusText(consultantInfo.status)"
      />
      <!-- 擅长知识 -->
      <skilled-knowledge :isShowBtn="isShowBtn" :consultant-id="consultantId" @knowledge-updated="handleKnowledgeUpdated" />

      <!-- 评价区域 -->
      <evaluation-section
        :consultant-id="consultantId"
        @evaluation-updated="handleEvaluationUpdated"
        :isOperator="isOperator"
      />

      <!-- 发布的知识 -->
      <published-knowledge-section
        class="section-container"
        :consultant-id="consultantId"
        :employeeId="consultantInfo.employeeId"
        :consultantInfo="consultantInfo"
        :isConsult="true"
      />

      <!-- 弹窗组件 -->
      <appointment-dialog
        :visible.sync="showAppointmentDialog"
        :consultant-id="consultantId"
        @close="handleAppointmentClose"
      />

      <!-- 分享弹窗 -->
      <share-qr :visible.sync="showShareDialog" :shareUrl="shareUrl" />

      <!-- 举报弹窗 -->
      <el-dialog
        :visible.sync="showReportDialog"
        width="500px"
        :show-close="true"
        @close="closeReportDialog"
        title="举报"
        class="dialog"
        destroy-on-close
      >
        <el-form ref="refReportForm" :model="reportFormData" :rules="reportFormRules" inline label-width="150px">
          <el-form-item label="举报">
            {{ reportFormData.reportUserName }}
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="reportFormData.type" placeholder="请选择类型" clearable>
              <el-option
                v-for="dict in getDict('report_type')"
                :key="dict.value"
                :label="dict.label"
                :value="dict.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input
              v-model="reportFormData.description"
              placeholder="请输入描述（可不填）"
              type="textarea"
              :rows="5"
              maxlength="300"
              resize="none"
              clearable
            />
          </el-form-item>
          <div style="text-align: center">
            <el-button type="primary" @click="handleConfirmReport">举报</el-button>
          </div>
        </el-form>
      </el-dialog>

      <!-- 评价弹窗 -->
      <el-dialog
        :visible.sync="showCommentDialog"
        width="400px"
        :show-close="true"
        @close="showCommentDialog = false"
        title="写评价"
        class="dialog"
      >
        <!-- <div class="comment-content">
          <div class="rating-section">
            <span>评分：</span>
            <div class="stars">
              <i
                v-for="i in 5"
                :key="i"
                class="el-icon-star"
                :class="{active: i <= commentScore}"
                @click="commentScore = i"
              />
            </div>
          </div>
          <el-input v-model="commentContent" type="textarea" rows="4" placeholder="请输入评价内容" />
          <div class="comment-footer">
            <el-button @click="showCommentDialog = false">取消</el-button>
            <el-button type="primary" @click="submitComment">提交</el-button>
          </div>
        </div> -->
      </el-dialog>
    </layoutContainer>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import appointmentDialog from './appointmentDialog.vue'
import shareQr from './shareQr.vue'
import operationArea from './operationArea.vue'
import skilledKnowledge from './skilledKnowledge.vue'
import evaluationSection from './evaluationSection.vue'
import publishedKnowledgeSection from './publishedKnowledgeSection.vue'
import {
  getConsultantBaseInfo,
  toggleFollow,
  cancelFollow,
  toggleCollection,
  deleteCollection,
  submitComment
} from '@/api/consultingService'
import {reportCreate} from '@/api/consultingRoom'
import {getDict} from '@/utils/dict'

export default {
  name: 'PersonalConsultDetail',
  components: {
    appointmentDialog,
    shareQr,
    operationArea,
    skilledKnowledge,
    evaluationSection,
    publishedKnowledgeSection
  },
  data() {
    return {
      consultantId: 0,
      consultantInfo: {
        consultantId: null,
        headPicUrl: '',
        gender: null,
        nickName: '',
        workedFamousCompanyList: [],
        occupationId: null,
        occupationName: '',
        workYears: null,
        knowledgeList: [],
        introduction: '',
        originalPrice: '',
        discountPrice: '',
        hasDiscount: false,
        saleNum: 0,
        evaluationScore: '',
        areaId: null,
        areaName: '',
        status: 1,
        collectionFlag: 0,
        followedFlag: 0,
        isAbilityAssessed: 0,
        abilityLevel: null,
        totalAmount: '',
        currentManagerFlag: 0,
        platformRecommendRank: 0,
        supportBargainFlag: 0,
        supportTogetherBuyFlag: 0
      },
      defaultAvatar: '/img/default-avatar.png',
      hasFollowed: false,
      hasCollected: false,
      collectionCount: 0,

      evaluationList: [],

      // 用户权限状态
      isSelf: true,
      isOperator: false,
      canEvaluate: false,
      hasBuyProxyPermission: false,

      // 弹窗状态
      showAppointmentDialog: false,
      showShareDialog: false,
      showReportDialog: false,
      showCommentDialog: false,

      // 弹窗数据
      reportReason: '',
      commentScore: 0,
      commentContent: '',

      // 举报表单数据
      reportFormData: {
        reportUserName: '',
        type: '',
        description: '',
        position: '咨询-个人详情',
        positionUrl: '/personalConsultDetail',
        businessInfo: ''
      },

      // 举报表单验证规则
      reportFormRules: {
        type: [{required: true, message: '请选择举报类型', trigger: 'change'}],
        description: [{max: 300, message: '描述不能超过300字', trigger: 'blur'}]
      },

      // 其他状态
      showMoreActions: false,
      followLoading: false,
      reportVisible: false
    }
  },
  computed: {
    ...mapState(['UserInfo']),
    hasFamousCompanies() {
      return this.consultantInfo.workedFamousCompanyList && this.consultantInfo.workedFamousCompanyList.length > 0
    },
    areaName() {
      let str = '';
      this.consultantInfo && this.consultantInfo.areaList && this.consultantInfo.areaList.forEach(item=>{
        str+=item.name + ' '
      })
      return str
    },
    canShowAppointmentButton() {
      // 如果状态不是"已上线"（status !== 1），则隐藏预约按钮
      if (this.consultantInfo.status !== 1) {
        return false
      }

      // 如果是承约人（currentConsultantUserFlag === 1）
      if (this.consultantInfo.currentConsultantUserFlag === 1) {
        // 如果承约人在营销中心开通了代买权限，则显示预约按钮
        return this.consultantInfo.currentAgentSaleAuthFlag === 1
      }
      // 如果不是承约人，则显示预约按钮
      return true
    },
    shareUrl() {
      const currentUrl = window.location.href

      // 检查URL是否已经包含查询参数
      const separator = currentUrl.includes('?') ? '&' : '?'

      // 构建分享URL，包含promote_type和promoter_id参数
      let shareUrl = `${currentUrl}${separator}promoter_id=${this.consultantInfo.currentUserId}&promote_type=share`

      return shareUrl
    },
    // isShowBtn
    isShowBtn() {
      return this.isCurrentConsultantUser || this.isAgentSaler
    },
    // 当前用户是否为承约人
    isCurrentConsultantUser() {
      return this.consultantInfo.currentConsultantUserFlag === 1
    },
    // 当前用户是否为运营人员
    isAgentSaler() {
      return this.consultantInfo.currentManagerFlag === 1
    }
  },
  created() {
    this.consultantId = Number(this.$route.query.consultant_id) || 0

    if (this.consultantId) {
      this.initData()
    }
  },
  methods: {
    getDict,
    // 显示预约弹层
    openAppointmentDialog() {
      this.showAppointmentDialog = true
    },

    // 初始化数据
    async initData() {
      try {
        // 获取顾问基本信息
        const baseInfoRes = await getConsultantBaseInfo({consultantId: this.consultantId})

        if (baseInfoRes.code === 200) {
          this.consultantInfo = baseInfoRes.data

          // 设置关注和收藏状态
          this.hasFollowed = this.consultantInfo.followedFlag === 1
          this.hasCollected = this.consultantInfo.collectionFlag === 1
        }

        // 获取当前用户信息和权限
        this.checkUserPermission()

        // 排序名企经历
        this.sortInfoList()
      } catch (error) {
        console.error('初始化数据失败:', error)
        this.$message.error('获取顾问信息失败，请重试')
      }
    },

    // 检查用户权限
    checkUserPermission() {
      const {currentConsultantUserFlag = 0, currentManagerFlag = 0} = this.consultantInfo
      this.isSelf = currentConsultantUserFlag === 1
      this.isOperator = currentManagerFlag === 1
      this.canEvaluate = !this.isSelf
      this.hasBuyProxyPermission = this.isSelf && false // 模拟，实际应从API获取
    },

    // 排序名企经历列表
    sortInfoList() {
      if (this.consultantInfo.workedFamousCompanyList) {
        this.consultantInfo.workedFamousCompanyList.sort((a, b) => (a.sequenceNum || 0) - (b.sequenceNum || 0))
      }
    },

    // 切换关注状态
    async toggleFollow() {
      const employeeId = this.consultantInfo.employeeId
      if (this.hasFollowed) {
        await cancelFollow({objectId: employeeId, objectType: '咨询'})
        this.hasFollowed = false
        this.$message.success('取消关注成功')
        return
      }
      this.followLoading = true
      try {
        await toggleFollow({objectId: this.consultantId, objectType: '咨询'})
        this.hasFollowed = !this.hasFollowed
        this.$message.success(this.hasFollowed ? '关注成功' : '取消关注成功')
      } catch (error) {
        console.error('切换关注状态失败:', error)
        // this.$message.error('操作失败，请重试')
      } finally {
        this.followLoading = false
      }
    },

    // 切换收藏状态
    async toggleCollection() {
      // 未登陆
      if (!this.UserInfo || !this.UserInfo.id) {
        this.$router.push('/login')
        return
      }
      if (this.hasCollected) {
        await deleteCollection({objectId: this.consultantId, objectType: '咨询'})
        this.hasCollected = false
        this.collectionCount -= 1
        this.$message.success('取消收藏成功')
        this.initData()
        return
      }

      try {
        await toggleCollection({objectId: this.consultantId, objectType: '咨询'})
        this.hasCollected = !this.hasCollected
        this.collectionCount += this.hasCollected ? 1 : -1
        this.$message.success(this.hasCollected ? '收藏成功' : '取消收藏成功')
        this.initData()
      } catch (error) {
        console.error('切换收藏状态失败:', error)
        // this.$message.error('操作失败，请重试')
      }
    },

    // 显示举报弹窗
    openReportDialog() {
      // 未登陆
      if (!this.UserInfo || !this.UserInfo.id) {
        this.$router.push('/login')
        return
      }
      this.reportFormData.reportUserName = this.consultantInfo.nickName || '未知用户'
      this.reportFormData.businessInfo = `受询人ID:${this.consultantId}`
      this.showReportDialog = true
    },

    // 关闭举报弹窗
    closeReportDialog() {
      this.showReportDialog = false
      this.reportFormData = {
        reportUserName: '',
        type: '',
        description: '',
        position: '详情',
        positionUrl: '/personalConsultDetail',
        businessInfo: ''
      }
      this.$nextTick(() => {
        this.$refs.refReportForm && this.$refs.refReportForm.clearValidate()
      })
    },

    // 确认举报
    handleConfirmReport() {
      this.$refs.refReportForm.validate(valid => {
        if (valid) {
          // 显示确认框
          this.$confirm('确定要提交举报吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              // 用户点击确定后提交举报
              reportCreate(this.reportFormData)
                .then(res => {
                  if (res.code === 200) {
                    this.$message.success('操作成功')
                    this.closeReportDialog()
                  } else {
                    this.$message.error(res.msg || '举报失败')
                  }
                })
                .catch(error => {
                  console.error('提交举报失败:', error)
                  // this.$message.error('举报失败，请重试')
                })
            })
            .catch(() => {
              // 用户点击取消，不做任何操作
            })
        }
      })
    },

    // 提交评价
    async submitComment() {
      if (this.commentScore === 0) {
        this.$message.error('请选择评分')
        return
      }
      if (!this.commentContent.trim()) {
        this.$message.error('请输入评价内容')
        return
      }
      try {
        await submitComment({
          consultantId: this.consultantId,
          score: this.commentScore,
          content: this.commentContent
        })
        this.$message.success('评价成功')
        this.showCommentDialog = false
        this.commentScore = 0
        this.commentContent = ''
        this.initData()
      } catch (error) {
        console.error('提交评价失败:', error)
        this.$message.error('评价失败，请重试')
      }
    },

    // 切换更多操作浮层
    toggleMoreActions() {
      this.showMoreActions = !this.showMoreActions
    },

    // 处理预约弹窗关闭
    handleAppointmentClose() {
      // 可以在这里处理预约成功后的逻辑
    },

    // 格式化时间
    formatTime(timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
        2,
        '0'
      )} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    },

    // 页面跳转
    goToPersonalPage() {
      const id = this.consultantInfo.employeeId
      this.$router.push(`/personal/detail/${id}`)
    },

    goToBargainPage() {
      // 跳转到砍价拼团页
      const courseId = this.consultantId
      const courseName = `预约-${this.consultantInfo.nickName || '咨询'}`
      const bargainTogetherType = 1 // 1-显示砍价列表
      const hasSupportBargain = this.consultantInfo.supportBargainFlag === 1 ? 'true' : 'false'
      const hasSupportTogetherBuy = this.consultantInfo.supportTogetherBuyFlag === 1 ? 'true' : 'false'
      const businessType = '咨询'

      this.$router.push({
        path: '/bargainPage',
        query: {
          courseId,
          courseName,
          bargainTogetherType,
          hasSupportBargain,
          hasSupportTogetherBuy,
          businessType
        }
      })
    },

    // 处理图片加载失败
    handleImageError(event) {
      event.target.src = this.defaultAvatar
    },

    // 编辑个人简介
    editIntroduction() {
      // 实现编辑简介功能
      this.$message.info('编辑简介功能待实现')
    },

    // 遮罩用户名
    maskUserName(name) {
      if (!name) return ''
      const firstChar = name.charAt(0)
      return firstChar + '***'
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '休息中',
        1: '已上线',
        2: '已下线'
      }
      return statusMap[status] || ''
    },

    // 获取状态样式类
    getStatusClass(status) {
      const classMap = {
        1: 'online',
        2: 'rest',
        3: 'offline'
      }
      return classMap[status] || ''
    },

    // 显示分享弹窗
    openShareDialog() {
      // 未登陆
      if (!this.UserInfo || !this.UserInfo.id) {
        this.$router.push('/login')
        return
      }
      this.showShareDialog = true
    },

    // 处理知识列表更新
    handleKnowledgeUpdated() {
      // 更新知识列表后重新初始化数据
      this.initData()
    },

    // 处理评价更新
    handleEvaluationUpdated(evaluationData) {
      // 更新consultantInfo中的评价信息
      if (evaluationData.showScore) {
        this.consultantInfo.evaluationScore = evaluationData.score
      } else {
        this.consultantInfo.evaluationScore = ''
      }
    },

    // 跳转到社保样例视频
    async goToExampleVideo() {
      try {
        // 从后端获取示例视频配置
        const {getDefaultSocialSecurity} = await import('@/api/socialSecurity')
        const response = await getDefaultSocialSecurity()
        if (response.code === 200 && response.data) {
          const {appId, psign, socialSecurityCloudFileId, fileName} = response.data
          // 跳转到视频播放页，传递四个参数
          this.$router.push({
            path: '/videoPlay',
            query: {
              appId,
              psign,
              socialSecurityCloudFileId,
              fileName: fileName || '社保记录示例'
            }
          })
        } else {
          this.$message.error('获取示例视频配置失败')
        }
      } catch (error) {
        console.error('获取示例视频配置失败:', error)
        this.$message.error('获取示例视频配置失败，请重试')
      }
    }
  },
  mounted() {
    // 点击页面其他区域关闭更多操作浮层
    document.addEventListener('click', e => {
      const moreActionsEl = document.querySelector('.more-actions-dropdown')
      const moreBtnEl = document.querySelector('.action-item:last-child')

      if (moreActionsEl && !moreActionsEl.contains(e.target) && moreBtnEl && !moreBtnEl.contains(e.target)) {
        this.showMoreActions = false
      }
    })
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-button {
  border: unset;
}
.personal-consult-detail {
  min-height: 100vh;
  background-color: #f5f7fa;

  .main-content {
    display: flex;
    gap: 20px;

    .left-section {
      flex: 3;
      background: #fff;
      border-radius: 8px;
      padding: 32px;
      position: relative;

      .basic-info {
        .top-info {
          position: relative;
          display: flex;
          align-items: flex-start;
          gap: 20px;
          margin-bottom: 32px;

          .user-avatar-section {
            .avatar-content {
              position: relative;
              width: 107px;
              height: 107px;
            }
            display: flex;
            align-items: center;
            gap: 16px;
            position: relative;

            .user-avatar {
              border: 2px solid #acacac;
              width: 107px;
              height: 107px;
              border-radius: 50%;
              object-fit: cover;
            }

            .gender-icon {
              width: 24px;
              height: 24px;
              position: absolute;
              top: 0px;
              right: 8px;
              z-index: 10px;
            }

            .user-name-section {
              .user-name {
                font-size: 20px;
                font-weight: 500;
                color: #333;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
                gap: 10px;
                // 超出显示省略号
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                .status-badge {
                  font-size: 14px;
                  font-weight: normal;

                  &.online {
                    color: #67c23a;
                  }

                  &.rest {
                    color: #e6a23c;
                    color: #e6a23c;
                  }

                  &.offline {
                    color: #f56c6c;
                  }
                }
              }

              .city-info {
                color: #999;
                display: flex;
                font-size: 18px;
                align-items: center;
                gap: 5px;
                .loc-img {
                  width: 24px;
                  height: 24px;
                }
              }
            }
          }
          .follow {
            &-btn {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              bottom: -10px;
              // width: 88px;
              padding: 0 15px;
              height: 35px;
              background: #5ad3cd;
              border-radius: 60px 60px 60px 60px;
              box-sizing: border-box;
              color: #fff;
            }
          }

          .action-buttons {
            // display: flex;
            // gap: 10px;
            height: 107px;
            line-height: 107px;
            // margin-left: auto;
            .action-btn {
              width: 104px;
              height: 35px;
              padding: 5px 16px;
              box-sizing: border-box;
              background: #5ad3cd;
              border-color: none;
              color: #fff;
              font-size: 18px;
              border-radius: 60px 60px 60px 60px;
              &.default {
                background: #ff724c;
                width: 68px;
                margin-left: 24px;
              }
            }
          }
          .appointment-section {
            .appointment-btn {
              right: 0;
              top: 18px;
              width: 268px;
              box-sizing: border-box;
              height: 74px;
              background: #5ad3cd;
              border-radius: 40px 40px 40px 40px;
              position: absolute;
              font-family: PingFang HK, PingFang HK;
              font-weight: 600;
              font-size: 24px;
            }
          }
        }

        .data-display {
          display: flex;
          // grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 15px;
          padding: 20px;
          background: #f8f8f8;
          border-radius: 12px;
          margin-bottom: 31px;
          justify-content: space-around;
          padding: 40px 93px;
          box-sizing: border-box;

          .data-item {
            // display: flex;
            // align-items: center;
            font-size: 22px;
            .question-icon {
              width: 20px;
              height: 20px;
            }

            .label {
              text-align: center;
              color: #999;
              margin-right: 10px;
            }

            .value {
              color: #333;
              font-weight: 500;
              text-align: center;
              margin-top: 8px;

              &.price-value {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;

                .original-price {
                  text-decoration: line-through;
                  color: #999;
                  font-size: 19px;
                  font-weight: normal;
                }

                .current-price {
                  font-size: 22px;
                  font-weight: 600;
                  color: #333333;
                }

                .price-tip-icon {
                  width: 16px;
                  height: 16px;
                  cursor: help;
                  color: #999;
                  margin-left: -5px;
                  margin-top: -5px;
                }
              }
            }
          }
        }

        .detail-info {
          .info-section {
            display: flex;
            margin-bottom: 40px;
            font-size: 22px;

            .section-title {
              flex-shrink: 0;
              font-weight: 500;
              color: #6d6d6d;
            }

            .company-list,
            .knowledge-list {
              // width: 500px;
              display: flex;
              flex-wrap: wrap;
              gap: 16px;
              margin-left: 50px;

              .company-item {
                padding: 0px 15px;
                border-radius: 16px;
                height: 32px;
                line-height: 32px;
                box-sizing: border-box;
                font-size: 20px;
                color: #ff724c;
                background: rgba(255, 114, 76, 0.16);
                border-radius: 4px 4px 4px 4px;
              }
              .knowledge-item {
                padding: 0px 15px;
                height: 36px;
                line-height: 36px;
                text-align: center;
                border-radius: 57px 57px 57px 57px;
                border: 1px solid #e6e6e6;
                color: #333;
              }
            }

            .knowledge-list {
              flex-wrap: wrap;
              overflow: hidden;
              white-space: nowrap;

              .knowledge-item {
                flex-shrink: 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 200px;
              }
            }

            .introduction-wrapper {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              margin-left: 50px;

              .introduction {
                width: 816px;
                flex: 1;
                flex-shrink: 0;
                line-height: 1.6;
                font-weight: 400;
                font-size: 20px;
                color: #333333;
                margin-right: 20px;
              }

              .introduction-actions {
                flex-shrink: 0;
              }
            }

            .example-video-wrapper {
              margin-left: 50px;

              .example-video-link {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                color: #5ad3cd;
                font-size: 20px;
                text-decoration: none;
                cursor: pointer;
                transition: color 0.3s;

                &:hover {
                  color: #4ab8b2;
                  text-decoration: underline;
                }

                i {
                  font-size: 22px;
                }
              }
            }
          }
        }
      }

      .evaluation-section {
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #e5e9ef;

        .section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .section-title {
            font-size: 18px;
            font-weight: 500;
            color: #333;
          }
        }

        .evaluation-list {
          .evaluation-item {
            padding: 15px 0;
            border-bottom: 1px solid #e5e9ef;

            &:last-child {
              border-bottom: none;
            }

            .evaluation-header {
              display: flex;
              align-items: center;
              gap: 10px;
              margin-bottom: 10px;

              .evaluator-name {
                font-size: 14px;
                color: #333;
                font-weight: 500;
              }

              .rating-stars {
                display: flex;
                gap: 2px;

                i {
                  color: #e4e7ed;

                  &.active {
                    color: #f56c6c;
                  }
                }
              }

              .evaluation-time {
                font-size: 12px;
                color: #999;
                margin-left: auto;
              }
            }

            .evaluation-content {
              font-size: 14px;
              color: #666;
              line-height: 1.6;
            }
          }
        }

        .empty-tip {
          text-align: center;
          color: #999;
          padding: 40px 0;
        }
      }
      .share-btn {
        width: 121px;
        box-sizing: border-box;
        display: flex;
        justify-content: end;
        height: 40px;
        align-items: center;
      }
    }

    .right-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .user-actions {
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        position: relative;

        .other-actions {
          display: flex;
          justify-content: space-around;

          .action-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            padding: 10px;
            border-radius: 4px;
            transition: background-color 0.2s;

            &:hover {
              background-color: #f5f7fa;
            }

            i {
              font-size: 24px;
              margin-bottom: 5px;
              color: #666;
            }

            span {
              font-size: 12px;
              color: #666;
            }
          }
        }

        .more-actions-dropdown {
          position: absolute;
          right: 20px;
          top: 100px;
          background: #fff;
          border: 1px solid #e5e9ef;
          border-radius: 4px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          min-width: 100px;
          z-index: 1000;

          .report-btn {
            color: #f56c6c;
          }
        }
      }
    }
    .bottom-btn {
      display: flex;
      justify-content: end;
      align-items: center;
      margin-top: 83px;
      .collect-btn {
        display: flex;
        align-items: center;
        .collection-num {
          font-size: 20px;
          margin-top: 3px;
        }
        &.active {
          color: #ffcf00;
        }
        .collect-icon {
          width: 28px;
          height: 28px;
          margin-right: 5px;
        }
        width: 121px;
        height: 40px;
        display: flex;
        align-items: center;
      }
      .share-btn {
        margin-right: 72px;
        width: 32px;
        height: 32px;
        cursor: pointer;
      }
    }
  }

  // 弹窗样式
  .dialog {
    .share-text,
    .report-content,
    .comment-content {
      padding: 20px 0;

      .share-text {
        text-align: center;
        margin-bottom: 20px;
      }

      .rating-section {
        margin-bottom: 10px;

        .stars {
          display: inline-block;
          margin-left: 10px;

          .el-icon-star {
            color: #e4e7ed;
            cursor: pointer;
            margin-right: 5px;

            &.active {
              color: #f56c6c;
            }
          }
        }
      }

      .report-footer,
      .comment-footer {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 20px;
      }
    }
  }

  // 动画效果
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
.report-popover {
  width: 121px;
  height: 59px;
  .report {
    // background: #ffffff;
    // box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px 8px 8px 8px;
    font-size: 22px;
    color: #eb5757;
    text-align: center;
    line-height: 59px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &-icon {
      width: 28px;
      height: 28px;
      margin-right: 5px;
    }
  }
  .more-icon {
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
}
.section-container {
  /deep/ .list {
    height: auto;
  }
  /deep/ .title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    .number {
      font-size: 16px;
      color: #999;
    }
  }
}
</style>
